import { useSelector } from 'react-redux';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ThreadlessThreadViewWrapper from 'conversations-thread-view/thread-view/components/ThreadlessThreadViewWrapper';
import { ComposeMessageButton as BaseComposeMessageButton } from 'composer-ui/compose/public/components';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getInitialThreadViewState } from 'conversations-inbox-lib/initialThreadView/public/selectors';
import { getAuth } from '../../auth/selectors/getAuth';
import { getBeaconUsageTracker, getUsageTracker } from '../../usage-tracking/clients/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const ComposeMessageButton = props => {
  const inboxId = useSelector(getCurrentInboxId);
  const omnibusData = useSelector(getInitialThreadViewState);
  const auth = useSelector(getAuth);
  return /*#__PURE__*/_jsx(ThreadlessThreadViewWrapper, {
    auth: auth,
    beaconTracker: getBeaconUsageTracker(),
    omnibusData: omnibusData,
    tracker: getUsageTracker(),
    children: /*#__PURE__*/_jsx(BaseComposeMessageButton, Object.assign({}, props, {
      inboxId: inboxId
    }))
  });
};
ComposeMessageButton.displayName = 'ComposeMessageButton';
export default ComposeMessageButton;